import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import {MutualBetslip, useMutualBetslip, useMutualSlipOptions} from "../../../features/betslip/mutual.service";

const DragHandle = SortableHandle(({children}: any) => children);

const SortableItem: any = SortableElement(({horse, run}: any) => <li>
    <DragHandle>
        <div className={"slip-item"}>
            <span className="text-xxsmall  horse-no">{horse.no}</span>
            <span className="text-xxsmall  horse-name">{horse.name}</span>

            <div className="slip-item-sort">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
                    <path d="M4.08325 8.75004L6.99992 11.6667L9.91659 8.75004M4.08325 5.25004L6.99992 2.33337L9.91659 5.25004"
                          stroke="var(--primary-color)" strokeWidth="1.66" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
            </div>
            <button onClick={() => {
                MutualBetslip.remove(1, run, horse);
            }} className="button xs tertiary outlined delete ">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M3.83329 5.33325V11.9999C3.83329 13.4727 5.0272 14.6666 6.49996 14.6666H10.5C11.9727 14.6666 13.1666 13.4727 13.1666 11.9999V5.33325M9.83329 7.33325V11.3333M7.16663 7.33325L7.16663 11.3333M11.1666 3.33325L10.2291 1.92698C9.98183 1.55605 9.56552 1.33325 9.11971 1.33325H7.88021C7.4344 1.33325 7.01809 1.55605 6.7708 1.92698L5.83329 3.33325M11.1666 3.33325H5.83329M11.1666 3.33325H14.5M5.83329 3.33325H2.49996"
                        stroke="var(--primary-color)" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
            </button>
        </div>
    </DragHandle>
</li>);

const SortableList: any = SortableContainer(({items, run}: any) => {
    return (
        <ul className="sortable-horses">
            {items.map((horse: any, index: number) => (
                <SortableItem key={`item-${horse.no}`} index={index} horse={horse} run={run}/>
            ))}
        </ul>
    );
});

export function SortMyHorse() {
    useMutualBetslip();
    const options = useMutualSlipOptions();
    const run = options.hippodrome?.runs?.find((r: any) => Number(r.no) === Number(options.bettingSubType?.id));
    if (!run) {
        return null;
    }
    const items = MutualBetslip.getCurrentItems()
        .map((el: any) => run.horses.find((h: any) => Number(h.no) === Number(el.horse)))
        .filter(Boolean);

    return (
        <SortableList items={items} run={run} useDragHandle={true} helperClass={"sortable-horse-helper"}
                      onSortEnd={({oldIndex, newIndex}: any) => MutualBetslip.reorder(oldIndex, newIndex)}/>
    );
}
